import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

export enum TooltipBodyDesigns {
  TemporaryAnimated = 'temporaryAnimated',
  TooltipHover = 'tooltipHover',
}

interface TooltipBodyProps {
  className?: string
  smallPadding?: boolean
  design: TooltipBodyDesigns
  hideXsmDown?: boolean
}

const TooltipBody: React.FC<React.PropsWithChildren<TooltipBodyProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        overflow: hidden;
        box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
        background-color: ${styleConstants.colors.gray_lightest};
        ${getFontCss(
          12,
          themeConstants.colors.font_primary,
          styleConstants.fontFamilies.regular,
        )};
        border-radius: ${styleConstants.borderRadius.tooltip};

        ${!!props.hideXsmDown &&
        css`
          ${getBreakpointDown(breakpointSizes.XSM)(css`
            display: none;
          `)}
        `}
      `}
    >
      <div
        css={css`
          background-color: ${themeConstants.colors.cta_dark};
          min-width: 4px;
          border-top-left-radius: ${styleConstants.borderRadius.tooltip};
          border-bottom-left-radius: ${styleConstants.borderRadius.tooltip};
        `}
      />
      <div
        css={css`
          border-top-right-radius: ${styleConstants.borderRadius.tooltip};
          border-bottom-right-radius: ${styleConstants.borderRadius.tooltip};
          overflow: hidden;
          display: flex;
          flex-direction: column;

          ${props.design === TooltipBodyDesigns.TemporaryAnimated &&
          css`
            padding: 4px 6px;
            white-space: nowrap;
          `}

          ${props.design === TooltipBodyDesigns.TooltipHover &&
          css`
            padding: 20px;
            white-space: normal;
          `}
        `}
      >
        {props.children}
      </div>
    </div>
  )
}

export default TooltipBody
